export const deleteUser = (userId: number) => `api/Users/${userId}`;

export const getUser = (userId: number) => `api/Users/${userId}`;

export const getAdministrationUserTable = (
  pageNum: number,
  maxPageRowCount: number,
  orderSearch: string,
  hiddenColumns: string[],
  fulltextKeyword: string | undefined
) => {
  let url = `api/Users/GetTable?pageNum=${pageNum}&maxPageRowCount=${maxPageRowCount}&orderSearch=${orderSearch}`;
  if (fulltextKeyword) url += `fulltextKeyword=${fulltextKeyword}`;
  hiddenColumns.forEach((column) => {
    url += `&ignoreColumns=${column}`;
  });
  return url;
};

export const updateUser = (keyValue: number | string) =>
  `api/Users/${keyValue}`;

export const postUser = () => "api/UserAccount/Register";

export const tmpPostUser = (
  userName: string,
  login: string,
  password: string
) =>
  `api/Administration/Register?username=${userName}&login=${login}&password=${password}`;

export const changePassword = () => "api/UserAccount/ChangePassword";

export const newPasswordAfterReset = () =>
  `api/UserAccount/NewPasswordAfterReset`;

export const resetPassword = (userId: number) =>
  `api/UserAccount/ResetPassword/${userId}`;

export const resetPasswordBulk = () => `api/UserAccount/ResetPasswordBulk`;

export const sendCredentials = () => `api/UserAccount/SendCredentials`;

export const sendCredentialsMulti = () =>
  `api/UserAccount/SendCredentialsMulti`;
